import Base from './base.js'

const cachedData = {}

class Platfrom extends Base {
  //获取顶级组织
  static getTopOrg() {
    return window.$httpUtil.instance.get('/api/pp/common/org/getTopOrg.json')
  }

  //获取所有组织
  static getOrgs() {
    return window.$httpUtil.instance.get('/api/pp/common/org/getOrgs.json')
  }

  //获取酒店城市
  static GethotelCityList() {
    return window.$httpUtil.instance.get('/api/hotel/web/allCity.json')
  }
  //获取火车城市
  static GettrainCityList(isNoNeedStation) {
    return window.$httpUtil.instance.get(`/api/train/web/allCity.json?excludeStation=${isNoNeedStation}`)
  }
  //获取机票城市
  static GetflightCityList() {
    return window.$httpUtil.instance.get('/api/flight/web/search/simpleCity.json')
  }
  static flightFlitercity() {
    return window.$httpUtil.instance.get('/api/flight/web/search/allCity.json')
  }
  static getSearchCity(keyword, bizType = '', isNoNeedStation) {
    let url = ''
    switch (bizType) {
      case 'flight':
        url = `/api/flight/web/search/findByKeyword.json?keyword=${keyword}&isIntlFlightSwitchTurnOn=${$ZConfig.getVal('isIntlFlightSwitchTurnOn')}`
        break
      case 'train':
        url = `/api/train/web/allCity.json?cityName=${keyword}&excludeStation=${isNoNeedStation}`
        break
      case 'hotel':
        url = `/api/hotel/web/queryCity.json?keyword=${keyword}&size=20`
        break
      case 'internationalFlight':
        url = `/api/pp/common/city/queryCity.json?cityName=${keyword}`
        break
      default:
        url = `/api/pp/common/city/queryCity.json?cityName=${keyword}`
        break
    }

    return window.$httpUtil.instance.get(url)
  }
  //国际城市
  static getdomeCity() {
    return window.$httpUtil.instance.get('/api/flight/web/baseData/domesticAirportCityGroup.json')
  }
  //admin:模式后台国内
  static prodomeCity() {
    return window.$httpUtil.instance.get('/api/flight/web/provider/rule/domesticAirportCityGroup.json')
  }
  //国内
  static getintCity() {
    return window.$httpUtil.instance.get('/api/flight/web/baseData/intlAirportCityGroup.json')
  }
  //admin:后台国内
  static prointCity() {
    return window.$httpUtil.instance.get('/api/flight/web/provider/rule/intlAirportCityGroup.json')
  }
  //前台关键字查询
  static flightcity(keyword) {
    return window.$httpUtil.instance.get(`/api/flight/web/baseData/findAirportCityByKeyWord.json?keyWord=${keyword}`)
  }
  //admin:后台关键字查询
  static procity(keyword) {
    return window.$httpUtil.instance.get(`/api/flight/web/provider/rule/findAirportCityByKeyWord.json?keyWord=${keyword}`)
  }
  //初始化用户信息，个人、菜单、企业信息
  static getInitData(force) {
    return window.$httpUtil.instance.get('/api/pp/common/platform/home/initData.json', null, {
      cacheKey: 'ss_initData',
      force
    })
  }

    //初始化用户企业信息
  static getPartnerList() {
    return window.$httpUtil.instance.get('/api/pp/common/platform/home/partnerList', null)
  }

  // 统计用户下载
  static getDownloadNumber() {
    return window.$httpUtil.instance.get('/api/pp/common/download/user/statistics.json')
  }

  //获取当前登录人用户信息
  static getCurUserInfo() {
    return window.$httpUtil.instance.get('/api/pp/common/platform/home/userInfo.json')
  }

  // 组织结构
  static getOrgListData(callback) {
    if (cachedData.getOrgListData) {
      callback && callback(JSON.parse(JSON.stringify(cachedData.getOrgListData)))
    } else {
      window.$httpUtil.instance.get('/api/pp/common/widget/org/getAllOrgs.json').then(res => {
        if (res.code === '0') {
          cachedData.getOrgListData = res
          callback && callback(JSON.parse(JSON.stringify(res)))
        }
      })
    }
  }

  // 组织层级
  static getOrgGrades(callback) {
    if (cachedData.getOrgGrades) {
      callback && callback(JSON.parse(JSON.stringify(cachedData.getOrgGrades)))
    } else {
      window.$httpUtil.instance.get('/api/pp/common/widget/orgGrade/getOrgGrades.json').then(res => {
        if (res.code === '0') {
          cachedData.getOrgGrades = res
          callback && callback(JSON.parse(JSON.stringify(res)))
        }
      })
    }
  }

  // 成本中心
  static getCostListData(callback) {
    if (cachedData.getCostListData) {
      callback && callback(JSON.parse(JSON.stringify(cachedData.getCostListData)))
    } else {
      window.$httpUtil.instance.get('/api/pp/common/widget/costCenter/getCostCenters.json').then(res => {
        if (res.code === '0') {
          cachedData.getCostListData = res
          callback && callback(JSON.parse(JSON.stringify(res)))
        }
      })
    }
  }

  // 费用类型
  static getAllCategory(callback) {
    if (cachedData.getAllCategory) {
      callback && callback(JSON.parse(JSON.stringify(cachedData.getAllCategory)))
    } else {
      window.$httpUtil.instance.get('expense/feeType/getAllCategory.json').then(res => {
        if (res.code === '0') {
          cachedData.getAllCategory = res
          callback && callback(JSON.parse(JSON.stringify(res)))
        }
      })
    }
  }

  //admin:备注
  static remarkgetList(orderId, OrderBizType) {
    return window.$httpUtil.instance.get(`tmc/serviceRemark/getList.json?orderId=${orderId}&OrderBizType=${OrderBizType}`)
  }

  //admin:新增备注
  static addRemark(parmas) {
    return window.$httpUtil.instance.post(`tmc/serviceRemark/add.json`, parmas)
  }

  //admin:删除备注
  static delReamrk(orderId) {
    return window.$httpUtil.instance.get(`tmc/serviceRemark/delete.json?id=${orderId}`)
  }
  static getMobileCodeV2 = () => {
    return window.$httpUtil.instance.get(
      `/api/pp/common/members/userSecurity/partner/switch/mobile/validate`
    )
  }

  static switchPartner = (data) => {
    return window.$httpUtil.instance.post(`/api/pp/common/members/userSecurity/switch/partner` ,data)
  }
  
  static verifyRequiredFlag = (data) => {
    return window.$httpUtil.instance.post(`/api/pp/common/members/userSecurity/switch/partner/required/verify` ,data)
  }

  // 展示企业列表判断是否需要验证
  static verifyUserSecurity = () => {
    return window.$httpUtil.instance.get(`/api/pp/common/members/userSecurity/userVerify`)
  }

    // 展示企业列表判断是否需要验证
  static verifyGroupUserSecurity = () => {
    return window.$httpUtil.instance.get(`/api/pp/common/members/userSecurity/groupUserVerify`)
  }

  static sendCodeCompanyList = () => {
    return window.$httpUtil.instance.get(`/api/pp/common/members/userSecurity/verify/mobile/sendCode`)
  }

  static verifyUserSecurityMobile= (code) => {
    return window.$httpUtil.instance.get(`/api/pp/common/members/userSecurity/verify/mobile?code=${code}`)
  }

  static getSecurityUserInfo() {
    return window.$httpUtil.instance.get('/members/userSecurity/userInfo')
  }
}

export default Platfrom
